import { render, staticRenderFns } from "./DistributionAccountManagement.vue?vue&type=template&id=9ce0f926&scoped=true"
import script from "./DistributionAccountManagement.vue?vue&type=script&lang=js"
export * from "./DistributionAccountManagement.vue?vue&type=script&lang=js"
import style0 from "./DistributionAccountManagement.vue?vue&type=style&index=0&id=9ce0f926&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce0f926",
  null
  
)

export default component.exports